import React, { useContext, useEffect, useRef, useState } from "react";
import LanguageContext from "../../utils/Contexts/LanguageContext";
import { useNavigate } from "react-router-dom";
import OrderDetail from "./OrderDetails/OrderDetail";
import PaymentMethods from "./PaymentMethods/PaymentMethods";
import axiosInstance from "../../utils/Requests/axios";
import ThemeContext from "../../utils/Contexts/ThemeContext";
import toast from "react-hot-toast";
import Footer from "../Footer";

import "./style.css";

function Cart() {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(1);
  const [cartData, setCartData] = useState(null);
  const [guestTotal, setGuestTotal] = useState(null);
  const [linkTotal, setLinkTotal] = useState(null);
  const [nicheTotal, setNicheTotal] = useState(null);
  const [guestPosts, setGuestPosts] = useState([]);
  const [linkInserts, setLinkInserts] = useState([]);
  const [nicheEdits, setNicheEdits] = useState([]);

  const getCartData = () => {
    const url = `/cart/items`;
    axiosInstance
      .get(url)
      .then((response) => {
        setCartData(response?.data);
      })
      .catch((error) => {
        if (error?.status === 404) {
          setCartData({ items: [] });
        } else {
          toast.error(t("There was an error fetching data"));
        }
      });
  };

  const orderDataFetched = useRef(false);
  useEffect(() => {
    if (orderDataFetched.current) return;
    orderDataFetched.current = true;
    getCartData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (cartData?.items) {
      const guestPostsItems = cartData?.items.filter((item) => item.type === 1);
      const linkInsertItems = cartData?.items.filter((item) => item.type === 2);
      const nicheEditItems = cartData?.items.filter((item) => item.type === 3);
      setGuestPosts(guestPostsItems);
      setLinkInserts(linkInsertItems);
      setNicheEdits(nicheEditItems);
      const guestTotal = cartData?.items
        .filter((item) => item.type === 1) // Filter items with type 1
        .reduce((sum, item) => sum + (item?.post?.offer?.price || 0), 0);
      setGuestTotal(guestTotal);
      const linksTotal = cartData?.items
        .filter((item) => item.type === 2) // Filter items with type 2
        .reduce((sum, item) => sum + (item?.insert?.offer?.price || 0), 0);
      setLinkTotal(linksTotal);
      const nicheTotal = cartData?.items
        .filter((item) => item.type === 3) // Filter items with type 2
        .reduce((sum, item) => sum + (item?.edit?.offer?.price || 0), 0);
      setNicheTotal(nicheTotal);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData]);

  return (
    <main id="content" role="main" className="main">
      <div className="content container-fluid">
        <div
          className="page-header"
          style={{
            position: "relative",
            paddingBottom: "unset",
            borderBottom: "unset",
          }}
        >
          <div
            style={{
              position: "absolute",
              bottom: "-12px",
              right: "0",
              left: "-25px",
              width: "100vw",
              height: "2px",
              backgroundColor: "var(--separator-bg)",
            }}
          ></div>
          <div className="row align-items-center mb-3">
            <div className="col-md d-md-flex justify-content-between flex-wrap align-items-center mb-sm-2 mb-2 mb-md-0">
              <div className="mb-sm-6 mb-lg-0 mb-md-4 mb-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb breadcrumb-no-gutter">
                    <li className="breadcrumb-item">
                      {/* eslint-disable-next-line */}
                      <a
                        className="breadcrumb-link cursor-pointer"
                        style={{
                          color: "rgba(145, 146, 147, 1)",
                          opacity: "50%",
                        }}
                        onClick={() => navigate("/cart")}
                      >
                        {t("Cart")}
                      </a>
                    </li>
                    {(activeStep === 1 || activeStep === 2) && (
                      <>
                        <li
                          className={`breadcrumb-item ${
                            activeStep === 2 ? "cursor-pointer" : ""
                          }`}
                          aria-current="page"
                          onClick={() =>
                            activeStep === 2 ? setActiveStep(1) : {}
                          }
                          style={{
                            color: "rgba(145, 146, 147, 1)",
                            opacity: activeStep === 1 ? "" : "50%",
                          }}
                        >
                          {t("Order Details")}
                        </li>
                        {activeStep === 2 && (
                          <li
                            className="breadcrumb-item"
                            style={{
                              color: "rgba(145, 146, 147, 1)",
                              opacity: activeStep === 2 ? "" : "50%",
                            }}
                            aria-current="page"
                          >
                            {t("Payment Method")}
                          </li>
                        )}
                      </>
                    )}
                  </ol>
                </nav>
                <h1 className="page-header-title">{t("Shopping Cart")}</h1>
              </div>
              <div className="d-flex gap-3">
                <div className="d-flex align-items-center gap-2 flex-column flex-sm-column flex-md-row">
                  <div
                    className={`rounded-circle d-flex justify-content-center align-items-center ${
                      activeStep === 1
                        ? "bg-primary text-white"
                        : selectedTheme === "dark"
                        ? "bg-step text-dark"
                        : "bg-secondary text-white"
                    }`}
                    style={{
                      height: "35px",
                      width: "35px",
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    1
                  </div>
                  <span className="text-center text-dark step-font">
                    {t("Order Details")}
                  </span>
                </div>
                <div
                  style={{
                    height: "2px",
                    width: "100px",
                    alignSelf: "center",
                    backgroundColor: "var(--separator-bg)",
                  }}
                ></div>
                <div className="d-flex align-items-center gap-2 flex-column flex-sm-column flex-md-row">
                  <div
                    className={`d-flex justify-content-center align-items-center rounded-circle ${
                      activeStep === 2
                        ? "bg-primary text-white"
                        : selectedTheme === "dark"
                        ? "bg-step text-step"
                        : "bg-secondary text-dark"
                    }`}
                    style={{
                      height: "35px",
                      width: "35px",
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    2
                  </div>
                  <span
                    className={`text-center step-font ${
                      activeStep === 2 ? "text-dark" : "text-step"
                    }`}
                  >
                    {t("Payment Method")}
                  </span>
                </div>
                <div
                  style={{
                    height: "2px",
                    width: "100px",
                    alignSelf: "center",
                    backgroundColor: "var(--separator-bg)",
                  }}
                ></div>
                <div className="d-flex align-items-center gap-2 flex-column flex-sm-column flex-md-row">
                  <div
                    className={`d-flex justify-content-center align-items-center rounded-circle ${
                      selectedTheme === "dark"
                        ? "bg-step text-step"
                        : "bg-secondary text-dark"
                    }`}
                    style={{
                      height: "35px",
                      width: "35px",
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    3
                  </div>
                  <span className="text-center text-step step-font">
                    {t("Order Confirmation")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {!cartData?.items?.length ? (
          <>
            <div className="text-center text-dark"></div>
            <div
              className="text-center p-4"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                textAlign: "center",
              }}
            >
              <img
                className="mb-3"
                src="https://static.articlesfactory.ai/app/svg/illustrations-light/oc-error.svg"
                alt=""
                style={{ width: "10rem" }}
                data-hs-theme-appearance="dark"
              />
              <img
                className="mb-3"
                src="https://static.articlesfactory.ai/app/svg/illustrations/oc-error.svg"
                alt=""
                style={{ width: "10rem" }}
                data-hs-theme-appearance="default"
              />
              <p className="mb-0">
                {cartData ? t("Cart is empty") : t("Loading data")}
              </p>
            </div>
          </>
        ) : (
          <>
            {activeStep === 1 && (
              <OrderDetail
                setActiveStep={setActiveStep}
                activeStep={activeStep}
                cartData={cartData}
                guestTotal={guestTotal}
                linkTotal={linkTotal}
                nicheTotal={nicheTotal}
                guestPosts={guestPosts}
                linkInserts={linkInserts}
                nicheEdits={nicheEdits}
                getCartData={getCartData}
              />
            )}
            {activeStep === 2 && (
              <PaymentMethods
                setActiveStep={setActiveStep}
                activeStep={activeStep}
                cartData={cartData}
                guestTotal={guestTotal}
                linkTotal={linkTotal}
                nicheTotal={nicheTotal}
                guestPosts={guestPosts}
                linkInserts={linkInserts}
                nicheEdits={nicheEdits}
                getCartData={getCartData}
              />
            )}
          </>
        )}
      </div>
      <Footer />
    </main>
  );
}

export default Cart;
